var map = {
	"./images/angular-js.png": 611,
	"./images/c-sharp.png": 612,
	"./images/cpp.png": 613,
	"./images/html-css.png": 614,
	"./images/java.png": 615,
	"./images/js.png": 616,
	"./images/levels/c-sharp-beginner.png": 1458,
	"./images/levels/c-sharp-expert.png": 1459,
	"./images/levels/c-sharp-intermediate.png": 1460,
	"./images/levels/java-beginner.png": 1461,
	"./images/levels/java-expert.png": 1462,
	"./images/levels/java-intermediate.png": 1463,
	"./images/levels/js-beginner.png": 1464,
	"./images/levels/js-expert.png": 1465,
	"./images/levels/js-intermediate.png": 1466,
	"./images/levels/php-beginner.png": 1467,
	"./images/levels/php-expert.png": 1468,
	"./images/levels/php-intermediate.png": 1469,
	"./images/levels/python-beginner.png": 1470,
	"./images/levels/python-expert.png": 1471,
	"./images/levels/python-intermediate.png": 1472,
	"./images/levels/solidity-beginner.png": 1473,
	"./images/levels/solidity-expert.png": 1474,
	"./images/levels/solidity-intermediate.png": 1475,
	"./images/node-js.png": 617,
	"./images/php.png": 618,
	"./images/python.png": 619,
	"./images/react-js.png": 620,
	"./images/solidity.png": 621,
	"./images/tech-writing.png": 622,
	"./images/vue-js.png": 623
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1457;


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations ^.*\.png$
// module id = 1457
// module chunks = 147